import { useFormContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export const FormErrors = () => {
  const form = useFormContext();
  const allErrors = useStore(form.store, (state) => state.errors);
  const formErrors = allErrors.filter((item) => 'form' in item).map((item) => item.form);

  return formErrors.length === 0 ? null : (
    <Stack gap={1}>
      {formErrors.map((error) => (
        <Alert key={error} severity="error">
          {error}
        </Alert>
      ))}
    </Stack>
  );
};
